import { ProductLine } from 'apis/restaurant-api/merchant-admin/venue/types';
import { useFeatureFlags } from 'common/hooks';
import useUser from 'common/hooks/useUser';

import { useCampaignModuleContext } from '../../context';

type FeatureFlagArgs = {
  venueId: string | undefined;
  country?: Country | string;
  city?: string;
  productLine?: ProductLine | string;
  enabled?: boolean;
};

export const useIsAdCampaignEnabled = ({ venueId, country, city, productLine, enabled = true }: FeatureFlagArgs) => {
  const { user } = useUser();
  const { entityType } = useCampaignModuleContext();
  const userId = user?.id || '';

  const eligibilityCriteria = {
    user_id: userId,
    country: country ?? '',
    city: city ?? '',
    entity_type: entityType,
    product_line: productLine ?? '',
    venue_id: venueId ?? '',
  };

  const {
    data: featureFlags,
    isLoading,
    isFetching,
  } = useFeatureFlags(
    ['ads-merchant-campaign-rollout'],
    {
      ...eligibilityCriteria,
    },
    { enabled },
  );

  return {
    isEnabled: featureFlags?.['ads-merchant-campaign-rollout'] === 'on',
    isLoading: isLoading && isFetching,
  };
};
